module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"account":"Ditt medlemskap","redirect":"Vennligst vent mens vi sender deg videre..."},"en":{"account":"Your membership","redirect":"Please wait while we are redirecting you..."}}')
  delete Component.options._Ctor
}
